export function applyLaborNorm(row, selected, rate1, rate2, rate3 = 0, rate4 = 0) {
  const hours = Number(selected.minute) > 0 ? Number(selected.minute) / 60 : 0;
  const rate = Number([rate1, rate2, rate3, rate4][Number(selected.skill) - 1]) || 0;
  return { ...row, bxqty_manopera: hours, bxpret_manopera: rate,
    bxtotal_manopera: Math.round((hours * rate + Number.EPSILON) * 100) / 100 };
}

export function updateLaborAmount(row, field, value) {
  const next = { ...row, [field]: value };
  const hours = Number(next.bxqty_manopera) || 0;
  if (field === 'bxtotal_manopera') {
    const rate = Number(next.bxpret_manopera) || 0;
    if (rate <= 0) return row;
    if (value === '') return { ...next, bxtotal_manopera: '', bxqty_manopera: 0 };
    next.bxtotal_manopera = Math.round(Math.max(0, Number(value) || 0) * 100) / 100;
    next.bxqty_manopera = next.bxtotal_manopera / rate;
  } else if (field === 'bxqty_manopera' || field === 'bxpret_manopera') {
    next.bxtotal_manopera = Math.round((hours * (Number(next.bxpret_manopera) || 0) + Number.EPSILON) * 100) / 100;
  }
  return next;
}
